export default "/images/cbs.svg?7bf9ec112736072d81f4ee5679ee8419";